import http from "../http-common";
import { getSeatAssignedCustomers } from "../shared/seatingTableDisplay";

const parseSeatingRecordDate = (dateStr) => {
  const parts = dateStr?.split('/');
  if (!parts || parts.length !== 3) return 0;
  return new Date(parts[2], parts[0] - 1, parts[1]).getTime();
};

/** Seating chart for a date, or the latest chart on or before that date (same fallback as Seating page). */
const resolveSeatingLayoutForDate = async (dateStr, selectedDate) => {
  const dated = await getAll(dateStr);
  const datedRows = dated?.data || [];
  if (datedRows.length > 0) {
    return datedRows[0]?.seating_assignment || null;
  }

  const allData = await getAll();
  const allRecords = allData?.data || [];
  if (!allRecords.length) return null;

  const selectedTime = new Date(selectedDate);
  selectedTime.setHours(23, 59, 59, 999);
  const sorted = allRecords
    .filter((r) => parseSeatingRecordDate(r?.date) <= selectedTime.getTime())
    .sort((a, b) => parseSeatingRecordDate(b?.date) - parseSeatingRecordDate(a?.date));

  return sorted[0]?.seating_assignment || null;
};

/**
 * All customers assigned to seats on the seating chart (deduped), with meal flags merged in.
 * @param {string} mealField - e.g. has_breakfast, has_lunch, has_snack
 */
const getAllCustomersFromSeatingChart = (seatingLayout, mealRecords, mealField) => {
  if (!seatingLayout?.tables) return [];
  const result = [];
  const seen = new Set();
  for (const tbl of Object.values(seatingLayout.tables)) {
      for (const seat of tbl.seats || []) {
        for (const assigned of getSeatAssignedCustomers(seat)) {
          const customerId = assigned.customerId;
          if (!customerId || seen.has(customerId)) continue;
          seen.add(customerId);
          const customer_name = assigned.customerName || '';
          const hasMeal = !!(mealRecords || []).find(
            (r) => r.customer_id === customerId && r[mealField]
          );
          result.push({
            customer_id: customerId,
            customer_name,
            [mealField]: hasMeal,
          });
        }
      }
  }
  return result.sort((a, b) =>
    (a.customer_name || '').localeCompare(b.customer_name || '', undefined, { sensitivity: 'base' })
  );
};

const getAll = (date) => {
  const params = {};
  if (date) {
    params.date = date;
  }
  return http.get("/seatings", {params});
};

const createNewSeating = (data) => {
  data.status = 'active';
	return http.post('/seatings', data);
};

const updateSeating = (id, data) => {
  return http.put(`/seatings/${id}`, data);
}

const deleteSeating = (id) => {
  return http.delete(`/seatings/${id}`)
}

export const SeatingService = {
	getAll,
	createNewSeating,
	updateSeating,
	deleteSeating,
	resolveSeatingLayoutForDate,
	getAllCustomersFromSeatingChart,
}